import { render, staticRenderFns } from "./assignment-contribute.vue?vue&type=template&id=5627e2b5&scoped=true"
import script from "./assignment-contribute.vue?vue&type=script&lang=js"
export * from "./assignment-contribute.vue?vue&type=script&lang=js"
import style0 from "./assignment-contribute.vue?vue&type=style&index=0&id=5627e2b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5627e2b5",
  null
  
)

export default component.exports